module.exports = __webpack_public_path__ + "img/home_list_icon1.6f270403.png";